/**
 * Slice 19c — chip strip rendered on an indexed post row in the Ads Assistant
 * aggregation list. Archetype tags sort first and use blue chips; topic (and
 * legacy un-kinded) tags fall back to the historical green chip styling.
 */
import type { AdsPostTagChip } from "@/lib/adsAssistantClient";

export function AdsPostTagChipsRow({ tags }: { tags: AdsPostTagChip[] }) {
  if (!tags.length) return null;
  const sorted = [...tags].sort(
    (a, b) => (a.kind === "archetype" ? 0 : 1) - (b.kind === "archetype" ? 0 : 1),
  );
  return (
    <div className="mt-1.5 flex flex-wrap gap-1" aria-label="Post tags">
      {sorted.map((t) => {
        const isArchetype = t.kind === "archetype";
        return (
          <span
            key={t.id}
            className={
              "rounded-full border px-2 py-0.5 text-[10px] font-medium " +
              (isArchetype
                ? "border-blue-200/90 bg-blue-50/90 text-blue-950 dark:border-blue-800 dark:bg-blue-950/35 dark:text-blue-100"
                : "border-emerald-200/90 bg-emerald-50/90 text-emerald-950 dark:border-emerald-800 dark:bg-emerald-950/35 dark:text-emerald-100")
            }
            title={isArchetype ? "Archetype tag (format)" : "Topic tag"}
          >
            {t.label}
          </span>
        );
      })}
    </div>
  );
}
